export const GET_FIELD_NOMINATIONS = '/api/UkNomination/List';
export const GET_FIELD_NOMINATIONS_GROUPED = '/api/UkNomination/GroupedList';
export const DOWNLOAD_FIELD_NOMINATIONS =
  '/api/UkNomination/DownloadUKNominationExcel';
export const UPDATE_FIELD_NOMINATIONS = '/api/UkNomination/Update';
export const GET_TERMINAL_MAPPINGS = (isValid: boolean) =>
  `/api/UkNomination/GetProdFieldTerminalMappings?isValid=${isValid}`;
export const ADD_UPDATE_TERMINAL_MAPPINGS =
  '/api/UKNomination/AddorUpdateTerminalMapping';
export const DELETE_TERMINAL_MAPPINGS =
  '/api/UkNomination/DeleteTerminalMapping';
export const DOWNLOAD_TERMINAL_MAPPINGS =
  '/api/UKNomination/DownloadTerminalMappingExcel';
export const GET_PRODUCTION_FIELDS =
  '/api/UkNomination/GetAllProductionFielddata';
export const GET_TERMINALS = '/api/cop/UKNomination/GetAllTerminal';
export const GET_SUB_TERMINALS = '/api/cop/UKNomination/GetAllSubTerminal';
export const GET_SOURCE_PRODUCTION_FIELDS =
  '/api/UkNomination/GetSourceProductionFielddata';
export const POST_UPLOAD_TO_ALIGNE = '/api/cop/UKNomination/UploadtoAligne';
export const GET_NOMINATION_DETAILS =
  '/api/UkNomination/GetDetailsForNomination';
export const POST_NOMINATION = '/api/UkNomination/Add';
export const GET_ALIGNE_PAYLOAD = '/api/cop/UKNomination/GetPayloadInfo';
export const UPDATE_NOMINATION_STATUS_TO_SUBMITTED =
  '/api/cop/UKNomination/UpdateNominationStatus';
export const GET_CURRENT_ALIGNE =
  '/api/cop/UKNomination/LoadAlignVolumeDataInDB';
export const FIELD_NOMS_DEADLINE_NOTIFICATION =
  '/api/cop/UKNomination/GetAllNotification';
export const FETCH_ALIGNE_STATUS = '/api/cop/UKNomination/FetchAligneStatus';

export const UPDATE_ADHOC_ALIGNE_CR_LOADING = `/api/cop/UKNomination/UpdateAdhocAligneCrLoadSwing`;

export const GET_UNMAPPED_SOURCE_PRODUCTION_FIELDS = `/api/UkNomination/GetUnmappedSourceProductionFields`;
export const UPDATE_NOMINATION_VISIBILITY = `/api/UkNomination/UpdateNominationVisibility`;

export const GET_UK_NOMINATION_LOGS = `/api/UkNomination/GetMappingAuditLog`;
export const UK_NOMINATION_RUN_G1_REPORT = `/api/cop/UKNomination/RunG1Report`;
export const UK_NOMINATION_GET_G1_STATUS_REPORT = `/api/cop/UKNomination/GetPsfReportAdFLogDetails`;
export const UK_NOMINATION_DOWNLOAD_G1_REPORT = `/api/cop/UKNomination/GetPsfReportExcel`;
export const UK_NOMINATION_START_STOP_G1_TRIGGER = `/api/cop/UKNomination/StartStopG1Trigger`;
export const UK_NOMINATION_DELETE_FIELD_NOMINATION = `/api/UkNomination/Delete`;
export const UPLOAD_TO_ENDUR = '/api/UkNomination/UploadToEndur';
export const GET_ENDUR_UPLOAD_AUDIT_LOG =
  '/api/UkNomination/GetEndurUploadAuditLog';
export const GET_DA_NOMS_AUDIT_LOG =
  '/api/UkNomination/GetDayAheadNominationAuditLog';
export const SYNC_DA_NOMS_TO_ENDUR =
  '/api/ManualSync/SyncDayAheadNominationToEndur';
export const GET_ENDUR_DEAL_IDS = '/api/UkNomination/GetEndurDealIds';
export const GET_ENDUR_PAYLOAD = '/api/UkNomination/GetEndurPayload';

export const GET_FIELD_NOMINATIONS_GROUPED_DATA =
  '/api/UkNomination/GroupedData';
export const CLONE_UK_NOMS = '/api/UkNomination/CloneUkNoms';

export const MESSAGES = {
  SERVER_ERROR: 'Something went wrong please contact system administrator.',
  REQUIRED_ENERGY: 'Energy is required',
  REQUIRED_Z_KEY: 'zKey is required',
  INVALID_Z_KEY: 'Please enter a valid zKey, it should only contain numbers',
  REQUIRED_UNIT: 'Unit is required',
  REQUIRED_PRODUCTION_FIELD: 'Production Field is required',
  REQUIRED_SOURCE_PRODUCTION_FIELD: 'Source Production Field is required',
  REQUIRED_COUNTERPARTY: 'Counterparty is required',
  REQUIRED_DEAL_UNIT: 'Deal Unit is required',
  REQUIRED_TERMINAL: 'Terminal is required',
  REQUIRED_SUB_TERMINAL: 'SubTerminal is required',
  REQUIRED_GAS_DAY: 'Gas Day is required',
  WD_DA_VARIANCE_RANGE: 'Value must be between 0 and 100',
  MAPPING_OVERRIDE:
    'Please note that when you addorupdate mapping, if the fields Deadline, Formula, WD Variance Breach, and DA Variance Breach are present for another mapping with the same Source Production Field, those values will be overridden.',
  SOMETHING_WENT_WRONG:
    "Something wen't wrong, Please try after sometime or Refresh the page.",
  REQUIRED_AUTOUPLOAD_TOLERANCE_VALUE:
    'Please enter autoupload tolerence value',
  REQUIRED_AUTOUPLOAD_TOLERANCE_TYPE: 'Autoupload Tolerence type is required',
  REQUIRED_DEAL_LEG_ID: 'Deal ID is required',
  INVALID_DEAL_LEG_ID:
    'Deal ID format is invalid. It should be in the format digits_digits (e.g. 123_4)',
  REQUIRED_FROM_DATE: 'From date is required',
  REQUIRED_TO_DATE: 'To date is required',
};

export const DEAL_UNIT_ENUM = [
  { id: 'kWh', name: 'kWh' },
  { id: 'Therms', name: 'Therms' },
];
